<template>
    <form @submit.prevent="emitSave" id="functionitemsAddEditDialog">
      <h4 class="mb-4">{{ 'ADD' | translate }}</h4>

      <div class="form-group" id="functionitemsAddEditDialog-formGroup-Omschrijving">
        <label>{{ 'id' | translate }}</label>
        <input type="number"
               class="form-control form-control-sm"
               v-model="functionitems.id" :disabled="edited"
               id="functionitemsAddEditDialog-formGroup-Omschrijving-input">
      </div>
    
      <div class="form-group" id="functionitemsAddEditDialog-formGroup-naam">
        <label>{{ 'Naam' | translate }} <span class="asterisk">*</span></label>
        <input type="text"
               class="form-control form-control-sm"
               v-model="functionitems.name"
               required
               id="functionitemsAddEditDialog-formGroup-naam-input">
      </div>
    
      <div class="form-group" id="functionitemsAddEditDialog-formGroup-Enabled">
        <label>{{ 'Enabled' | translate }}</label>
        <input type="checkbox"
               class="form-control form-control-sm"
               v-model="functionitems.enabled"
               id="functionitemsAddEditDialog-formGroup-Enabled-input">
      </div>
    
      <div class="mt-4 text-right" id="functionitemsAddEditDialog-formGroup-buttons">
    
        <button class="btn btn-link" type="button"
                @click="emitClose"
                id="functionitemsAddEditDialog-closeButton"
        >{{ 'CLOSE' | translate }}</button>
    
        <button class="btn btn-primary"
                type="submit"
                :disabled="!isFormValid"
                id="functionitemsAddEditDialog-addButton"
        >{{ 'ADD' | translate }}</button>
    
      </div>
    </form>
    </template>
    
    <script>
    import GeneralConfigService from '../../../service/GeneralConfigService';
    
    export default {
      props: [ 'edited' ],
      data() {
        return {
          functionitems: {}
        }
      },
      computed: {
        isFormValid() {
          return this.functionitems.name;
        }
      },
      methods: {
        emitSave() {
          this.$emit(this.edited ? 'update' : 'save', this.functionitems);
          if (this.functionitems.enabled) {
            GeneralConfigService.addOrUpdateEnabledFunctionItems(this.functionitems);
          } else {
            GeneralConfigService.removeEnabledFunctionItems(this.functionitems);
          }
          this.functionitems = {};
        },
        emitClose() {
          this.$emit('close');
          this.functionitems = {};
        }
      },
      watch: {
        edited(newVal, oldVal) {
          this.functionitems = {...newVal};
        }
      }
    }
    </script>
    
    <style lang="scss" scoped>
    .asterisk {
      color: $danger;
    }
    
    >>> .vdp-datepicker__calendar {
      bottom: 30px;
    }
    </style>
    


// WEBPACK FOOTER //
// src/components/admin/functionitems/FunctionItemsAddEditDialog.vue